/**
 * Shopify Forms an eine frei waehlbare Stelle im Beitrag/auf der Seite holen.
 *
 * Hintergrund: Shopify Forms ist ein App-Block. Seine Position ist im Template
 * festgelegt und die Formular-ID kommt aus dem Metafeld (dynamische Quelle).
 * Redaktionell laesst sich die Position damit nicht steuern.
 *
 * Loesung: Im Beitragstext einen Platzhalter setzen -
 *     <div class="blog-embed"></div>
 * Dieses Skript schiebt den App-Block dorthin und blendet den leeren
 * Abschnitt an der urspruenglichen Stelle aus.
 *
 * Ohne Platzhalter bleibt alles wie bisher: das Formular erscheint an der
 * Position, die im Template hinterlegt ist.
 */
(function () {
  var SLOT_SELECTOR = '.blog-embed, [data-cdx-form]';
  var placed = false;

  function place() {
    if (placed) return true;

    var slot = document.querySelector(SLOT_SELECTOR);
    if (!slot) return false;

    var root = document.querySelector('[data-form-root]');
    if (!root) return false;

    var block = root.closest('.shopify-app-block') || root;

    if (slot.contains(block)) {
      placed = true;
      return true;
    }

    var section = block.closest('.shopify-section');

    slot.appendChild(block);
    slot.setAttribute('data-cdx-form-placed', 'true');

    // Urspruenglichen Abschnitt nur ausblenden, wenn dort nichts anderes mehr steht.
    if (section && !section.querySelector('.shopify-app-block')) {
      section.style.display = 'none';
    }

    placed = true;
    return true;
  }

  function watch() {
    if (place()) return;

    // Platzhalter oder App-Block koennen nachtraeglich im DOM landen.
    var observer = new MutationObserver(function () {
      if (place()) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    // Nach 10s aufgeben, damit kein Observer dauerhaft mitlaeuft.
    setTimeout(function () {
      observer.disconnect();
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
